export default "__VITE_ASSET__3eb3de54__"